import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import Button from '../components/ui/Button';

const Booking = () => {
  const [step, setStep] = useState(1);

  // Demo form handler
  const handleNext = (e) => {
    e.preventDefault();
    if (step < 3) setStep(step + 1);
  };

  return (
    <div className="bg-veloura-bg min-h-screen">
      <PageHeader title="Book Appointment" bgImage="https://images.unsplash.com/photo-1512496015851-a1c825b27264?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-3xl py-24">
        <SectionHeading title="Reserve Your Time" subtitle="Online Booking" />
        
        <div className="bg-white rounded-[2rem] shadow-sm border border-veloura-primary/20 overflow-hidden">
          
          {/* Progress Bar */}
          <div className="flex border-b border-veloura-primary/30">
            {['Service', 'Date & Time', 'Details'].map((label, i) => (
              <div key={i} className={`flex-1 text-center py-4 text-sm font-medium transition-colors ${step >= i + 1 ? 'bg-veloura-primary/20 text-veloura-accent' : 'text-veloura-muted'}`}>
                {i + 1}. {label}
              </div>
            ))}
          </div>

          <div className="p-8 md:p-12">
            {step === 1 && (
              <motion.div 
                initial={{ opacity: 0, x: 20 }} 
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
              >
                <h3 className="font-serif text-2xl mb-6">Select a Service</h3>
                <div className="space-y-4">
                  {['Classic Full Set - $95', 'Hybrid Full Set - $120', 'Volume Full Set - $145', 'Lash Lift & Tint - $85', 'Refill (Any Style)'].map((srv, i) => (
                    <label key={i} className="flex items-center p-4 border border-veloura-primary/50 rounded-xl cursor-pointer hover:border-veloura-accent transition-colors">
                      <input type="radio" name="service" className="w-5 h-5 text-veloura-accent focus:ring-veloura-accent border-gray-300" />
                      <span className="ml-4 text-veloura-text font-medium">{srv}</span>
                    </label>
                  ))}
                </div>
                <div className="mt-8 flex justify-end">
                  <Button onClick={handleNext} variant="primary">Continue</Button>
                </div>
              </motion.div>
            )}

            {step === 2 && (
              <motion.div 
                initial={{ opacity: 0, x: 20 }} 
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
              >
                <h3 className="font-serif text-2xl mb-6">Select Date & Time</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium mb-2">Select Date</label>
                    <input type="date" className="w-full p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Select Time</label>
                    <select className="w-full p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent bg-white">
                      <option>10:00 AM</option>
                      <option>11:30 AM</option>
                      <option>1:00 PM</option>
                      <option>2:30 PM</option>
                      <option>4:00 PM</option>
                    </select>
                  </div>
                </div>
                <div className="mt-8 flex justify-between">
                  <Button onClick={() => setStep(1)} variant="outline">Back</Button>
                  <Button onClick={handleNext} variant="primary">Continue</Button>
                </div>
              </motion.div>
            )}

            {step === 3 && (
              <motion.div 
                initial={{ opacity: 0, x: 20 }} 
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
              >
                <h3 className="font-serif text-2xl mb-6">Your Details</h3>
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <input type="text" placeholder="First Name" className="p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent" />
                    <input type="text" placeholder="Last Name" className="p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent" />
                  </div>
                  <input type="email" placeholder="Email Address" className="w-full p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent" />
                  <input type="tel" placeholder="Phone Number" className="w-full p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent" />
                  <textarea placeholder="Any notes for your artist?" rows="3" className="w-full p-3 border border-veloura-primary rounded-lg focus:outline-none focus:border-veloura-accent"></textarea>
                  
                  <div className="bg-veloura-primary/10 p-4 rounded-lg mt-4 text-sm text-veloura-muted">
                    <p><strong>Booking Policy:</strong> A non-refundable $25 deposit is required to secure your appointment. This will be applied to your final total.</p>
                  </div>
                </div>
                <div className="mt-8 flex justify-between">
                  <Button onClick={() => setStep(2)} variant="outline">Back</Button>
                  <Button onClick={() => alert('Demo: Appointment request submitted!')} variant="primary">Confirm Booking</Button>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;